<template>
  <div class="flex flex-wrap">
    <div class="md:w-1/3 w-1/2 pt-5">
      <a href="/admin/users" class="no-underline">
        <div class="bg-yellow-500 p-12 rounded-full h-16 w-16 flex mx-auto items-center justify-center text-white">
          <d-icon size="2x" icon="user" />
        </div>
        <p class="text-center mt-3">Users</p>
      </a>
    </div>

    <div class="md:w-1/3 w-1/2 pt-5">
      <a href="/admin/announcements" class="no-underline">
        <div class="bg-yellow-500 p-12 rounded-full h-16 w-16 flex mx-auto items-center justify-center text-white">
          <d-icon size="2x" icon="bullhorn" />
        </div>
        <p class="text-center mt-3">Announcements</p>
      </a>
    </div>

    <div class="md:w-1/3 w-1/2 pt-5">
      <a href="/admin/groups" class="no-underline">
        <div class="bg-yellow-500 p-12 rounded-full h-16 w-16 flex mx-auto items-center justify-center text-white">
          <d-icon size="2x" icon="users" />
        </div>
        <p class="text-center mt-3">Groups</p>
      </a>
    </div>

    <div class="md:w-1/3 w-1/2 pt-5">
      <a href="/admin/communities" class="no-underline">
        <div class="bg-yellow-500 p-12 rounded-full h-16 w-16 flex mx-auto items-center justify-center text-white">
          <d-icon size="2x" icon="home" />
        </div>
        <p class="text-center mt-3">Communities</p>
      </a>
    </div>

    <div class="md:w-1/3 w-1/2 pt-5">
      <a href="/admin/schools" class="no-underline">
        <div class="bg-yellow-500 p-12 rounded-full h-16 w-16 flex mx-auto items-center justify-center text-white">
          <d-icon size="2x" icon="school" />
        </div>
        <p class="text-center mt-3">Schools</p>
      </a>
    </div>

    <div class="md:w-1/3 w-1/2 pt-5">
      <a href="/admin/system-config" class="no-underline">
        <div class="bg-yellow-500 p-12 rounded-full h-16 w-16 flex mx-auto items-center justify-center text-white">
          <d-icon size="2x" icon="cog" />
        </div>
        <p class="text-center mt-3">System Config</p>
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    parent: true,
  };
</script>